import React, { useRef, useEffect } from 'react';
import * as THREE from 'three';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls';

const ThreeDVisuals = () => {
  const mountRef = useRef(null);

  useEffect(() => {
    const width = mountRef.current.clientWidth;
    const height = mountRef.current.clientHeight;
    const scene = new THREE.Scene();
    const camera = new THREE.PerspectiveCamera(75, width / height, 0.1, 1000);
    const renderer = new THREE.WebGLRenderer();
    renderer.setSize(width, height);
    const domElement = renderer.domElement;
    mountRef.current.appendChild(domElement);

    // Add ambient light with increased intensity
    const ambientLight = new THREE.AmbientLight(0x404040, 3); // Increased intensity to 3
    scene.add(ambientLight);

    // Add point light with increased intensity and distance
    const pointLight = new THREE.PointLight(0xffffff, 1.5, 150);
    pointLight.position.set(20, 20, 20);
    scene.add(pointLight);

    // Add directional light for better illumination
    const directionalLight = new THREE.DirectionalLight(0xffffff, 0.5);
    directionalLight.position.set(0, 1, 1);
    scene.add(directionalLight);

    // Create a geometry
    const geometry = new THREE.TorusKnotGeometry(10, 3, 100, 16);
    const material = new THREE.MeshStandardMaterial({ // Changed to MeshStandardMaterial for better lighting interaction
      color: 0x755C5C,
      metalness: 0.6, // Added metalness for reflectivity
      roughness: 0.4 // Added roughness to control the surface texture
    });
    const torusKnot = new THREE.Mesh(geometry, material);
    scene.add(torusKnot);

    camera.position.z = 50;

    // Add orbit controls
    const controls = new OrbitControls(camera, domElement);
    controls.update();

    const animate = () => {
      requestAnimationFrame(animate);
      torusKnot.rotation.x += 0.01;
      torusKnot.rotation.y += 0.01;
      controls.update();
      renderer.render(scene, camera);
    };

    animate();

    // Capture the current value of mountRef.current
    const currentMountRef = mountRef.current;

    return () => {
      if (currentMountRef && currentMountRef.contains(domElement)) {
        currentMountRef.removeChild(domElement);
      }
    };
  }, []);

  return <div ref={mountRef} style={{ width: '100%', height: '100vh' }} />;
};

export default ThreeDVisuals;
